import { useEffect, useRef } from "react";
import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import PageListPageContainer from "./PageListPageContainer";
import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";
import ModalWrap from "components/other/ModalWrap";
import Backdrop from "components/other/Backdrop";
import ModalWindow from "components/other/ModalWindow";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import ButtonWhite from "components/buttons/ButtonWhite";

import leftIcon from "assets/img/icons/left-arrow.svg";
import rightIcon from "assets/img/icons/right-arrow.svg";
import leftWhiteIcon from "assets/img/icons/left-arrow-white.svg";
import rightWhiteIcon from "assets/img/icons/right-arrow-white.svg";
import blockIcon from "assets/img/icons/icons8-unavailable.svg";

const PageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const Pagination = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  justify-content: center;
  gap: ${css.BUTTONS_GAP_SMALL};

  @media (max-width: ${globalConstants.switchTablet}) {
    margin-top: 6px;
    margin-bottom: ${css.VERTICAL_BOX_MARGIN};
  }
`;

const ConfirmDelete = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: auto;
  transform: translateX(-50%) translateY(-50%);

  width: 100%;
  max-width: 442px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 200;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${globalConstants.switchMobile}) {
    width: 100%;
  }
`;

const ConfirmDeleteWrap = styled.div`
  margin-top: 60px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ConfirmDeleteText = styled.div`
  line-height: 130%;
`;

const ConfirmDeleteButtons = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_XLARGE};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${css.BUTTONS_GAP};
`;

const NoResultsBox = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
`;

const NoResults = styled.div`
  width: 100%;
  margin-top: 60px;
  margin-bottom: 60px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const NoResultsIcon = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
`;

const NoResultsText = styled.div`
  text-align: center;
`;

export default ({
  data,
  limit,
  page,
  paginate,
  refetch,
  onDeleteClick,
  confirmDelete,
  closeDeleteModal,
  onConfirmDelete,
  confirmDuplicate,
  closeDuplicateModal,
  onDuplicateClick,
  onConfirmDuplicate,
}) => {
  const numOfResults = data.pageListData.numOfResults;

  const list = data.pageListData.pages.map((page) => {
    const { id, code, name, list, redirect_link, stats, views, leads } = page;

    let listReady = true;

    const {
      behalf_name,
      behalf_street,
      behalf_email,
      behalf_city,
      behalf_zip,
      behalf_country,
    } = list;

    if (
      !behalf_name ||
      !behalf_street ||
      !behalf_email ||
      !behalf_city ||
      !behalf_zip ||
      !behalf_country
    ) {
      listReady = false;
    }

    return (
      <PageListPageContainer
        id={id}
        code={code}
        name={name}
        list={list}
        stats={stats}
        views={views}
        leads={leads}
        redirectLink={redirect_link}
        pageLists={data.pageListData.pageLists}
        refetch={refetch}
        onDeleteClick={onDeleteClick}
        onDuplicateClick={onDuplicateClick}
        listReady={listReady}
      />
    );
  });

  let pageToDelete = null;

  if (data && confirmDelete) {
    pageToDelete = data.pageListData.pages.find(
      (page) => page.id === confirmDelete
    );
  }

  let pageToDuplicate = null;

  if (data && confirmDuplicate) {
    pageToDuplicate = data.pageListData.pages.find(
      (page) => page.id === confirmDuplicate
    );
  }

  // prepare pagination
  let showPagination = false;

  if (numOfResults > limit) showPagination = true;

  const maxPage = Math.ceil(numOfResults / limit);

  console.log({ page, numOfResults, limit, showPagination });

  return (
    <PageList>
      {list}
      {showPagination && (
        <Pagination>
          {page > 1 && (
            <ButtonRoundIcon
              icon={leftIcon}
              hoverIcon={leftWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("previous")}
            />
          )}
          {page < maxPage && (
            <ButtonRoundIcon
              icon={rightIcon}
              hoverIcon={rightWhiteIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              iconSize="16px"
              buttonSize="32px"
              onClick={() => paginate("next")}
            />
          )}
        </Pagination>
      )}
      {pageToDelete && (
        <ModalWrap>
          <Backdrop
            onClick={closeDeleteModal}
            background="rgba(0, 0, 0, 0.7)"
          />
          <ConfirmDelete>
            <ModalWindow
              title="Delete Page"
              handleModalClose={closeDeleteModal}
              fullScreenHeight={true}
            >
              <ConfirmDeleteWrap>
                <ConfirmDeleteText>
                  Do you really want to delete the page "{pageToDelete.name}
                  "? The leads it collected will remain stored in your mailing
                  list.
                </ConfirmDeleteText>
                <ConfirmDeleteButtons>
                  <ButtonWhite onClick={closeDeleteModal}>Cancel</ButtonWhite>
                  <ButtonPrimary onClick={onConfirmDelete}>
                    Delete
                  </ButtonPrimary>
                </ConfirmDeleteButtons>
              </ConfirmDeleteWrap>
            </ModalWindow>
          </ConfirmDelete>
        </ModalWrap>
      )}
      {pageToDuplicate && (
        <ModalWrap>
          <Backdrop
            onClick={closeDuplicateModal}
            background="rgba(0, 0, 0, 0.7)"
          />
          <ConfirmDelete>
            <ModalWindow
              title="Duplicate Page"
              handleModalClose={closeDuplicateModal}
              fullScreenHeight={true}
            >
              <ConfirmDeleteWrap>
                <ConfirmDeleteText>
                  Do you want to create a new page by duplicating the "
                  {pageToDuplicate.name}" page?
                </ConfirmDeleteText>
                <ConfirmDeleteButtons>
                  <ButtonWhite onClick={closeDuplicateModal}>
                    Cancel
                  </ButtonWhite>
                  <ButtonPrimary onClick={onConfirmDuplicate}>
                    Duplicate
                  </ButtonPrimary>
                </ConfirmDeleteButtons>
              </ConfirmDeleteWrap>
            </ModalWindow>
          </ConfirmDelete>
        </ModalWrap>
      )}
      {list.length === 0 && (
        <NoResultsBox>
          <NoResults>
            <NoResultsIcon>
              <img src={blockIcon} style={{ width: "100%" }} />
            </NoResultsIcon>
            <NoResultsText>
              You don’t have any landing pages. Click the Create New Page button
              to create your first page.
            </NoResultsText>
          </NoResults>
        </NoResultsBox>
      )}
    </PageList>
  );
};
